import React from 'react'

const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="#9ca3af" strokeWidth="2"/>
    <line x1="12" y1="8" x2="12" y2="12" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round"/>
    <line x1="12" y1="16" x2="12.01" y2="16" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

interface WizardCheckboxProps {
  label: string
  description?: string
  checked: boolean
  onChange: (checked: boolean) => void
  showInfoIcon?: boolean
}

const WizardCheckbox = ({ label, description, checked, onChange, showInfoIcon }: WizardCheckboxProps) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      padding: '16px',
      border: '1.5px solid #e5e7eb',
      borderRadius: '10px',
      cursor: 'pointer',
    }}
    onClick={() => onChange(!checked)}
  >
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      onClick={(e) => e.stopPropagation()}
      style={{ marginTop: '2px', width: '16px', height: '16px', cursor: 'pointer', flexShrink: 0, accentColor: '#2196F3' }}
    />
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        {showInfoIcon && <InfoIcon />}
        <span style={{ fontSize: '0.875rem', fontWeight: 600, color: '#0a0d47' }}>{label}</span>
      </div>
      {description && <span style={{ fontSize: '0.8125rem', color: '#6b7280' }}>{description}</span>}
    </div>
  </div>
)

export default WizardCheckbox
